import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { GeocodedPlace } from '../models/geocoded-place.model';

export interface IGeocodingRepository {
  search(query: string): Observable<readonly GeocodedPlace[]>;
  /** Reverse geocoding: resolves a point back to an address. Null when nothing is known for it. */
  reverse(latitude: number, longitude: number): Observable<GeocodedPlace | null>;
}

export const GEOCODING_REPOSITORY = new InjectionToken<IGeocodingRepository>('IGeocodingRepository');
